<template>
    <div>
        <!-- Bouton principal -->
        <button class="btn btn-primary" @click="toggleForm">
            {{ showForm ? 'Annuler' : 'Envoyer par email' }}
        </button>

        <!-- Formulaire affiché après clic -->
        <div v-if="showForm" class="mt-3">
            <div class="input-group">
                <input type="email" class="form-control" v-model="emailInput" placeholder="Entrez l'adresse email">
                <div class="input-group-append">
                    <button class="btn btn-success" @click="sendEmail">
                        <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SendEmailButton",
    props: {
        devisId: {
            type: String
        },
        email: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            showForm: false,
            emailInput: this.email
        };
    },
    methods: {
        toggleForm() {
            this.showForm = !this.showForm;
            if (this.showForm && !this.emailInput) {
                this.emailInput = "";
            }
        },
        sendEmail() {
            if (!this.emailInput) {
                alert("Veuillez entrer une adresse email.");
                return;
            }
            this.axios.post(`/api/devis/${this.devisId}/send-email`, {
                email: this.emailInput
            })
                .then(response => {
                    this.showForm = false;
                })
                .catch(error => {
                    console.error(error);
                    alert("Erreur lors de l'envoi du devis.");
                });
        },
    }
};
</script>